import { render, staticRenderFns } from "./EnterpriseInformation.vue?vue&type=template&id=bf5ba6b2&scoped=true&"
import script from "./EnterpriseInformation.vue?vue&type=script&lang=js&"
export * from "./EnterpriseInformation.vue?vue&type=script&lang=js&"
import style0 from "./EnterpriseInformation.vue?vue&type=style&index=0&id=bf5ba6b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf5ba6b2",
  null
  
)

export default component.exports